import { Delete, Edit } from "@mui/icons-material";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TableSkeleton from "components/skeletons/TableSkeleton";
import { deletePayment } from "features/invoices/bank/api/invoiceBank";
import useFormatter from "hooks/useFormatter";
import { toast } from "react-toastify";
export function getOrdinal(number) {
  const suffixes = ["th", "st", "nd", "rd"];
  const absNumber = Math.abs(number);

  if (absNumber % 100 >= 11 && absNumber % 100 <= 13) {
    return absNumber + "th";
  } else {
    const suffixIndex = absNumber % 10 <= 3 ? absNumber % 10 : 0;
    return absNumber + suffixes[suffixIndex];
  }
}
const PaymentTable = ({
  profile,
  loading,
  allPayment,
  setAddPayment,
  setCurrPayment,
  setAllPayment,
  symbol,
}) => {
  const { formatCurrency } = useFormatter();
  const rows = allPayment;
  const columns = [
    { id: "month", label: "Month" },

    { id: "interest_amount", label: "Interest Rate" },
    { id: "loan_amount", label: "Loan Amount" },
    { id: "charge", label: "Charge/Month" },
    {
      id: "action",
      label: "Actions",
      style: { width: "130px" },
      align: "center",
    },
  ];

  const handleDelete = async (id) => {
    try {
      const result = await deletePayment(id);
      if (result.success) {
        toast.success(result.message);
        setAllPayment(allPayment.filter((task) => task.id !== id));
        // setReloadMain((prev) => !prev);
      } else {
        toast.error(result.message);
      }
    } catch {}
  };

  const handleEditBtn = (value) => {
    setCurrPayment(value);
    setAddPayment(true);
  };

  return (
    <>
      {!loading ? (
        <>
          <TableContainer
            sx={{
              maxHeight: "calc(100vh - 256px)",
              overflowX: "auto",
              ml: "-20px",
              mr: "-20px",
              width: "calc(100% + 40px)",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map((row) => {
                  return (
                    <TableRow hover role="checkbox" key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.id === "interest_amount" ? (
                              formatCurrency(value)
                            ) : column.id === "loan_amount" ? (
                              formatCurrency(profile?.loan_amount)
                            ) : column.id === "charge" ? (
                              <>{formatCurrency(value)}</>
                            ) : column.id === "month" ? (
                              getOrdinal(value)
                            ) : column.id === "action" ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "10px",
                                  justifyContent: "center",
                                }}
                              >
                                <IconButton onClick={() => handleEditBtn(row)}>
                                  <Edit />
                                </IconButton>
                                <IconButton
                                  onClick={() => handleDelete(row.id)}
                                >
                                  <Delete />
                                </IconButton>
                              </Box>
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Total amount count */}
          <Box
            sx={{
              mt: "10px",

              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Typography sx={{ fontWeight: "500" }} align="right">
              Total Charge:
            </Typography>
            <Typography sx={{ fontWeight: "500" }} align="right">
              {symbol}
              {formatCurrency(rows.reduce((acc, curr) => acc + curr.charge, 0))}
            </Typography>
          </Box>
        </>
      ) : (
        <TableSkeleton columns={columns} tableHeight="calc(100vh - 265px)" />
      )}
    </>
  );
};

export default PaymentTable;
